"use client";

import { c as _c } from "react/compiler-runtime";
import OverlappingAvatars from "@/components/common/OverlappingAvatars";
import type { ApiWave } from "@/generated/models/ApiWave";
import { numberWithCommas } from "@/helpers/Helpers";
export default function WaveItemDropped(t0) {
  const $ = _c(18);
  const {
    wave
  } = t0;
  let t1;
  if ($[0] !== wave.contributors_overview) {
    t1 = wave.contributors_overview ?? [];
    $[0] = wave.contributors_overview;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const contributors = t1;
  let t2;
  if ($[2] !== contributors) {
    t2 = contributors.map(_temp);
    $[2] = contributors;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <div className="tw-hidden tw-flex-shrink @[320px]/wave:tw-flex"><OverlappingAvatars items={t2} maxCount={5} size="sm" overlapClass="-tw-space-x-1" onItemClick={_temp2} /></div>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== wave.metrics.drops_count) {
    t4 = numberWithCommas(wave.metrics.drops_count);
    $[6] = wave.metrics.drops_count;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t4) {
    t5 = <span className="tw-flex-shrink-0 tw-text-sm tw-font-medium tw-text-white">{t4}</span>;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const t6 = wave.metrics.drops_count === 1 ? "Drop" : "Drops";
  let t7;
  if ($[10] !== t6) {
    t7 = <span className="tw-min-w-0 tw-truncate tw-font-normal tw-text-iron-500">{t6}</span>;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t5 || $[13] !== t7) {
    t8 = <div className="tw-flex tw-min-w-0 tw-items-center tw-gap-x-1 tw-text-sm">{t5}{t7}</div>;
    $[12] = t5;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t3 || $[16] !== t8) {
    t9 = <div className="tw-flex tw-min-w-0 tw-items-center tw-gap-x-2">{t3}{t8}</div>;
    $[15] = t3;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  return t9;
}
function _temp2(e) {
  return e.stopPropagation();
}
function _temp(c, index) {
  const href = c.contributor_identity ? `/${c.contributor_identity}` : undefined;
  return {
    key: `${c.contributor_identity ?? "anon"}-${c.contributor_pfp ?? "no-pfp"}-${index}`,
    pfpUrl: c.contributor_pfp ?? null,
    ...(href !== undefined && {
      href
    }),
    ariaLabel: c.contributor_identity ? `View @${c.contributor_identity}` : "View contributor profile",
    fallback: c.contributor_identity?.slice(0, 2).toUpperCase() ?? "?"
  };
}